<template>
    <span style="width: 100%;">
        <i :class="data.iconName" :style="this.data.type ==1?iconStyle:''"></i>
    </span>
</template>

<script>

  import {iconStyle, loadStyleString} from '../js/common'

  let list = [];
  export default {
    props: {
      componentData: {
        type: String
      },
    },
    name: "eleIcon",
    data() {
      return {
        data: {},
      }
    },
    computed: {
      iconStyle() {
        if (this.data.type == 1) {
          return {
            color: this.data.iconColor, 'font-size': `${this.data.iconSize}px`
          }
        } else {
          return iconStyle(this.data);
        }
      },
    },
    created() {
      if (this.componentData) {
        this.data = JSON.parse(this.componentData);
        if (this.data.type == 2) {
          loadStyleString(this.iconStyle);
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleIcon.vue